import { render, staticRenderFns } from "./AProductTypeTreeSelector.vue?vue&type=template&id=58299e8c&"
import script from "./AProductTypeTreeSelector.vue?vue&type=script&lang=js&"
export * from "./AProductTypeTreeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports